import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { ProjectReadView } from '@atlassian/jira-servicedesk-insight-attribute-views/src/ui/project/index.tsx';
import type { CmdbObjectAttributeProject } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/attribute.tsx';

export type Props = {
	attribute: CmdbObjectAttributeProject;
};

export const ProjectAttribute = (props: Props): React.JSX.Element => {
	const { attribute } = props;

	return (
		<Wrapper>
			{attribute.objectAttributeValues.map(({ project: { avatarUrl, key, name, id } }) => (
				<ProjectReadView key={id} projectKey={key} avatarUrl={avatarUrl} displayName={name} />
			))}
		</Wrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	display: 'flex',
	flexWrap: 'wrap',
	gap: token('space.100'),
});
